module.exports = __webpack_public_path__ + "img/20190531162523QQ截图20190527164633.2fb835ad.png";